import { connect } from 'react-redux';

import BaseComponent from '../../../components/BaseComponent';
import { bulkMailVendorConfig } from '../../../entity/HRM/bulkMaillVenderConfig';

class BulkMailVender extends BaseComponent {
  constructor(props) {
    super(props);
    this.config = { ...bulkMailVendorConfig };
    this.getResponse();
  }
}



const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(BulkMailVender);
